import { gql } from "@apollo/client";

const TOP_BANNER_FRAGMENT = gql`
  fragment TopBannerReturn on TopBanner {
    id
    createdAt
    updatedAt
    image
    url
  }
`;

export const TOP_BANNERS = gql`
  ${TOP_BANNER_FRAGMENT}
  query TOP_BANNERS($skip: Int, $take: Int) {
    topBanners(skip: $skip, take: $take) {
      ...TopBannerReturn
    }
    topBannersCount
  }
`;

export const CREATE_TOP_BANNER = gql`
  ${TOP_BANNER_FRAGMENT}
  mutation CREATE_TOP_BANNER($data: CreateTopBannerInput!) {
    createTopBanner(data: $data) {
      ...TopBannerReturn
    }
  }
`;

export const UPDATE_TOP_BANNER = gql`
  ${TOP_BANNER_FRAGMENT}
  mutation UPDATE_TOP_BANNER(
    $where: TopBannerWhereInput!
    $data: UpdateTopBannerInput!
  ) {
    updateTopBanner(where: $where, data: $data) {
      ...TopBannerReturn
    }
  }
`;

export const DELETE_TOP_BANNER = gql`
  ${TOP_BANNER_FRAGMENT}
  mutation DELETE_TOP_BANNER($where: TopBannerWhereInput!) {
    deleteTopBanner(where: $where) {
      ...TopBannerReturn
    }
  }
`;
